export const WarningOptionComp = () => {

    return (
        <i 
            className="fa-solid fa-circle-exclamation text-warning fs-6"
            title="Documento não registrado na base de dados. Para salvar, clique em ANEXAR."
        />
    )
}